export const DMS_MODULE = 'Sestavy';
export const NAME = 'BulkInventoryAdjustments';
export const CRUMB_LABEL_KEY = 'BulkInventoryAdjustments';
export const DEPENDENT_TABLES_ALL = <const>[];
export type DependentTableNames = typeof DEPENDENT_TABLES_ALL[number];
export const DEFAULT_ID = 1;
export const DEFAULT_INDEX = 0;
export const UPLOADED_BULKINVENTORY = 'UploadedBulkInventory';
export const UPLOADED_BULKINVENTORY_ERROR = 'Uploaded Bulk Inventory Error';
export const EXPORT_INVENTORY_COLUMN = 'EXPORT_INVENTORY'
export const FILE_NAME = 'FILE_NAME';
export const ERROR_COUNT = 'ERROR_COUNT';
export const APPROVED = 'APPROVED';
export const PENDING = 'PENDING';
export const DRAFT = 'DRAFT';
export const REJECTED = 'REJECTED';
export const STATUS = 'STATUS';
export const DELETE_COFIRM_MESSAGE = 'DELETE_COFIRM_MESSAGE';
export const SURE_TO_DELETE_CONFIRM = 'SURE_TO_DELETE_CONFIRM';
export const CONFIRM = 'confirm'; 
export const ZERO_ERROR_COUNT = 'ZeroErrorCount';
export const DMS3_INFO_TITLE = 'DMS3_InfoTitle';
export const NOT_IN_DRAFT_STATUS = 'NotInDraftStatus';
export const ALREADY_APPROVED_INADMISSIBLE = 'AlreadyApprovedInAdmissible';
export const ALREADY_REJECTED_INADMISSIBLE = 'AlreadyRejectedInAdmissible';
export const ALREADY_SUBMITTED_INADMISSIBLE = 'AlreadySubmittedInAdmissible';
export const ZERO_RECORD_INADMISSIBLE = 'ZeroRecordInAdmissible';
export const APPROVAL_NOTE = 'APPROVAL_NOTE';
export const ERROR_INADMISSIBLE = 'ErrorInAdmissible';
export const SELECT_WAREHOUSE = 'SelectWarehouse';
export const FILE_UPLOAD_SUCCESS = 'FileUploadSuccess';
export const NO_DATA_FILE = 'NoDataFile';
export const SELECT_FILE = 'SelectFile';
export const BULK_INVENTORY_FILE_DELETION_ERROR_MESSAGE = 'bulkInventoryFileDeletionErrorMessage';
export const UNABLE_TO_UPLOAD = 'UNABLE_TO_UPLOAD';
export const UNABLE_TO_EXPORT = 'UNABLE_TO_EXPORT';

export enum BulkInventoryStatus {
	PENDING = 0,
	APPROVED = 1,
	REJECTED = 2,
	DRAFT = 3
}